<template>
  <div class="block-container">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'BlockContainer',
  props: [],
};
</script>

<style lang="stylus" scoped>
  @require '../style/colors'

  .block-container
    display: flex
    flex-flow: wrap
    justify-content: center

    @media only screen and (max-width: 850px)
      flex-direction: column-reverse
      align-items: center

    >*
      box-sizing: border-box
      max-width: 60rem
      min-height: 50rem
      width: 50%
      padding: 5rem

      @media only screen and (max-width: 850px)
        min-width: auto
        width: 100%

</style>
